import { PropsWithChildren } from 'react';

type BadgeProps = PropsWithChildren & {
    badgeStyle: 'primary' | 'secondary';
    //size: 'xs' | 'sm' | 'md' | 'lg';
};

export const Badge = ({ badgeStyle, children }: BadgeProps) => {
    let badgeClasses = 'rounded-full font-semibold text-sm pb-0.5 pt-0.5 pl-2 pr-2';

    switch (badgeStyle) {
        case 'primary':
            badgeClasses += ' bg-green-600 text-white';
            break;
        case 'secondary':
            badgeClasses += ' bg-white text-green-600';
            break;
    }

    return <span className={badgeClasses}>{children}</span>;
};
